import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/discovery.svg';

export const IconDiscovery = createIconComponent(Icon);
